import {
  equipoCreateDuck,
  equipoDeleteDuck,
  equipoEditDuck,
  equipoGetDuck,
  equiposGetDuck,
  equiposOptionsGetDuck,
} from './duck';

const equipoReducers = {
  equipoGet: equipoGetDuck.reducer,
  equiposGet: equiposGetDuck.reducer,
  equipoCreate: equipoCreateDuck.reducer,
  equipoEdit: equipoEditDuck.reducer,
  equipoDelete: equipoDeleteDuck.reducer,
  equiposOptions: equiposOptionsGetDuck.reducer,
};

export {equipoReducers};
